import { configureIntercom } from '@seek/hirer-intercom-adapter';
import { useEffect } from 'react';
import { shallowEqual, useSelector } from 'react-redux';

import { useConfig } from 'src/app/shared/hooks/useConfig';

import type { EmployerSiteName } from '../../../types/app';
import type { AppState } from '../../../types/appState';

interface Props {
  site: EmployerSiteName;
}

export const IntercomConfiguration = ({ site }: Props) => {
  const { email, userFirstName, userLastName } = useSelector(
    (state: AppState) => ({
      email: state.session.userEmailAddress,
      userFirstName: state.session.userFirstName,
      userLastName: state.session.userLastName,
    }),
    shallowEqual,
  );
  const language = useConfig().getLanguage();

  // @TODO: In future get isCSView from GET_HEADER_FOOTER_CONTEXT gql and store in redux
  const isImpersonating = false;

  useEffect(() => {
    if (email && userFirstName && userLastName && !isImpersonating) {
      const name = `${userFirstName} ${userLastName}`.trimEnd();
      configureIntercom({
        email,
        name,
        site,
        language,
      });
    }
  }, [email, userFirstName, userLastName, isImpersonating, site, language]);

  return null;
};
